import { Api } from "../api/Api";

export const useFollowupUserSignature = () => {
  const saveFollowupUserSignature = async (
    signature_data,
    followup_data,
    message_type
  ) => {
    const signatureSubmit = await Api.post("/api/v1/data-ingestion-pipeline", {
      signature_data,
      followup_data,
      message_type,
    });
    return signatureSubmit;
  };
  return {
    saveFollowupUserSignature,
  };
};
